import {DriveStep} from 'driver.js'
import {PageKey} from '../../@contexts'
import {CapitalizeFirstLetter} from './StringManipulation'
import {Card2Type} from '../../@types'

export interface DriverStepsInterface<T> {
    page: PageKey
    cards: T[];
    additionalSteps?: DriveStep[];
}

export const GetDriverSteps = <T extends Pick<Card2Type, 'body'>>(
    config: DriverStepsInterface<T>,
): DriveStep[] => {

    const {cards, additionalSteps = [], page} = config

    const cardSteps: DriveStep[] = cards.map(({body: {text, description}}, index) => ({
        element: `#${page}-step-${index}`,
        popover: {
            title: CapitalizeFirstLetter(text),
            description: description,
        },
    }))

    return [...cardSteps, ...additionalSteps]
}
